import { render, staticRenderFns } from "./QuantityChart.vue?vue&type=template&id=6e08087c&scoped=true"
import script from "./QuantityChart.vue?vue&type=script&lang=js"
export * from "./QuantityChart.vue?vue&type=script&lang=js"
import style0 from "./QuantityChart.vue?vue&type=style&index=0&id=6e08087c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08087c",
  null
  
)

export default component.exports